/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setSelectedWorkstation } from "../store/slice/roomSlices/workstationRoomSlice";
import { setCenterGraph, setIsLoading } from "../store/slice/centerGraphSlice";
import { getWorkstationRoomData } from "../multiplayer/SocketConnection";
import { setOpenedKPI } from "../store/slice/roomSlices/homeSlice";
import { WORKSTATION_ROOM } from "../rooms/RoomNameConstants";
import { changeRoomHandler } from "./ChangeRoomHandlers";
import store from "../store/store";

const workstationRoomSetup = (data) => {
    getWorkstationRoomData(data)

    store.dispatch(setOpenedKPI({ opened: null }));
}

export const handleGoToWorkstationRoom = (
    selectedWorkstation
) => {
    let engineList = [], engines = store.getState().user.engines;

    const dataToCache = {
        key: "centerGraph",
        data: store.getState().centerGraph,
        callback: (cachedData) => {
            store.dispatch(setCenterGraph(cachedData))
        },
    }

    engines.selected.forEach((engineName) => {
        engineList.push(engines.list.find((engine) => engine.name === engineName))
    });

    store.dispatch(setIsLoading(true))
    store.dispatch(setSelectedWorkstation(selectedWorkstation))

    changeRoomHandler(
        WORKSTATION_ROOM,
        workstationRoomSetup({
            workstationName: selectedWorkstation.name,
            engineList,
            targetRoom: WORKSTATION_ROOM
        }),
        dataToCache
    )
}